import { axiosHelper } from 'Services/AxiosHelper';
import { getApiGWTokenCookie } from 'Utils';
import { checkVposReqBodyData } from 'Config';

const command = 'RI.CheckVposPayment';

const checkVposPayment = async (params: checkVposReqBodyData): Promise<any> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default checkVposPayment;
